export const getRandomNumber = (max: number = 1000) => {
  return Math.floor(Math.random() * max);
};
